var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMusicLover = function SvgMusicLover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M11.229 2.796a2.6 2.6 0 0 0-.854-.59 2.56 2.56 0 0 0-2.014 0c-.32.137-.61.337-.854.59L7 3.319l-.507-.523A2.6 2.6 0 0 0 4.632 2c-.698 0-1.368.286-1.861.796A2.76 2.76 0 0 0 2 4.716c0 .72.277 1.41.77 1.92l.508.523L7 11l3.722-3.84.507-.524c.244-.252.438-.551.57-.88a2.8 2.8 0 0 0 0-2.08 2.7 2.7 0 0 0-.57-.88z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M21 13c0-6-5.661-6-5.661-9.548v16.467c0 .908-.611 1.695-1.49 1.927l-2.148.567A2 2 0 0 1 9.19 20.48V19.32a2 2 0 0 1 1.489-1.933l4.66-1.232"
  })));
};
export default SvgMusicLover;